export function DecorativeDivider({ variant = 'heart' }: { variant?: 'heart' | 'note' }) {
  return <span className="decorative-divider" aria-hidden="true"><i /><b>{variant === 'note' ? '♫' : '♥'}</b><i /></span>
}
